import type { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { baseDroneApi } from '@src/core/features/drone/redux/api';
import { orderFeatureApi } from '@src/features/order/redux/api';
import { analyticsFeatureApi } from '@src/features/analytics/redux/api';

/**
 * After `POST /hubs/{id}/select` (or hub mutations that change scope), invalidate hub-scoped slices.
 * @see HUBS_FRONTEND_INTEGRATION.md §2.4, §3.7
 */
export function invalidateHubScopedCaches(dispatch: ThunkDispatch<unknown, unknown, AnyAction>): void {
  dispatch(baseDroneApi.util.invalidateTags(['GetDrones', 'GetDroneHistory', 'GetDroneMaintenance', 'DroneFirmware']));
  dispatch(orderFeatureApi.util.invalidateTags(['Orders', 'OrderDetails']));
  dispatch(analyticsFeatureApi.util.invalidateTags(['AnalyticsMetrics', 'AnalyticsCharts']));
}
